import {ChoiceValue} from "data/models/survey/choice-base";


export function sortChoiceValues(items: ChoiceValue[]) {
  return items.sort((a, b) => {
    const aLower = a.value.toLowerCase();
    const bLower = b.value.toLowerCase();
    return (aLower < bLower) ? -1 : (aLower > bLower ? 1 : 0)
  });
}
